import React from 'react';
import styles from './RecentGameRow.module.css';
import CupBoard from '../../../Shared/CupBoard/CupBoard';
import { getUserTeam, getDisplayPlayers, isUserWin, getUserScores } from './gameUtils';

const RecentGameRow = ({ game, username, expanded, onToggle }) => {
  const userTeam = getUserTeam(game, username) ?? 'home';
  const { user, teammate, opp1, opp2 } = getDisplayPlayers(game, username, userTeam);
  const win = isUserWin(game, username);
  const { userScore, oppScore } = getUserScores(game, username);
  const flipBoard = userTeam === 'away';

  // When flipped (away team): user's cups (def) are on top, opp's cups (off) on bottom
  // When not flipped (home team): opp's cups (off) on top, user's cups (def) on bottom
  const topPrefix   = flipBoard ? 'def' : 'off';
  const bottomPrefix = flipBoard ? 'off' : 'def';
  const topType     = flipBoard ? 'DF' : 'AT';
  const bottomType  = flipBoard ? 'AT' : 'DF';
  // Labels: user is always at the bottom, opponent always at the top
  const topLabels = [opp1?.name, opp2?.name];
  const botLabels = [user?.name, teammate?.name];

  const getVal = (prefix, pos) => game.cups?.[`${prefix}_${pos}`]?.value;

  return (
    <div className={`${styles.gameItem} ${game.lap && win ? styles.lapRow : game.lap && !win ? styles.lapLossRow : ''}`}>
      <button className={styles.gameButton} onClick={onToggle}>
        <span>
          <span className={styles.userHighlight}>{user?.name}</span>
          {' & '}{teammate?.name}
          {' vs '}
          {opp1?.name} & {opp2?.name}
        </span>
        <span>
          <span className={win ? styles.gameWinBadge : styles.gameLossBadge}>{win ? 'W' : 'L'}</span>
          {game.lap && win && <span className={styles.lapBadge}>LAP</span>}
          {game.lap && !win && <span className={styles.lapLossBadge}>LAPPED</span>}
          <span className={styles.gameScore}>{userScore} – {oppScore}</span>
          <span className={styles.gameChevron}>{expanded ? ' ▲' : ' ▼'}</span>
        </span>
      </button>

      {expanded && (
        <div className={styles.boxScoreContainer}>
          <div className={styles.playersGrid}>
            {[user, teammate, opp1, opp2].map((p, i) => (
              <div key={i} className={styles.playerColumn}>
                <strong>{p?.name}</strong>
                <p>Half: {p?.halfCups}</p>
                <p>Full: {p?.fullCups}</p>
                <p>Own: {p?.ownCups}</p>
                <p>Saves: {p?.saves}</p>
              </div>
            ))}
          </div>

          <div className={styles.miniBoardWrapper}>
            <div className={styles.boardHeader}>
              <span className={styles.boardHeaderLabel}>{topLabels[0]}</span>
              <span className={styles.boardHeaderLabel}>{topLabels[1]}</span>
            </div>
            <CupBoard
              variant="mini"
              topType={topType}
              bottomType={bottomType}
              attackData={{
                bk: getVal(topPrefix, 'bk'),
                ct: getVal(topPrefix, 'ct'),
                lf: getVal(topPrefix, 'lf'),
                rt: getVal(topPrefix, 'rt'),
                fr: getVal(topPrefix, 'fr'),
              }}
              defenseData={{
                fr: getVal(bottomPrefix, 'fr'),
                rt: getVal(bottomPrefix, 'rt'),
                lf: getVal(bottomPrefix, 'lf'),
                ct: getVal(bottomPrefix, 'ct'),
                bk: getVal(bottomPrefix, 'bk'),
              }}
            />
            <div className={styles.boardFooterLabels}>
              <span className={`${styles.boardHeaderLabel} ${styles.userHighlight}`}>{botLabels[0]}</span>
              <span className={styles.boardHeaderLabel}>{botLabels[1]}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecentGameRow;
